import script from "./MailBox.vue?vue&type=script&setup=true&lang=js"
export * from "./MailBox.vue?vue&type=script&setup=true&lang=js"

import "./MailBox.vue?vue&type=style&index=0&id=387258ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-387258ac"]])

export default __exports__